var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faceDelay"},[_c('div',{staticClass:"container",attrs:{"id":"link"}},[(_vm.isPractice)?_c('Practice'):_vm._e(),_c('ul',{staticClass:"nodes"},_vm._l((_vm.nodeList),function(item,index){return _c('li',{key:'left' + index,class:_vm.current >= index ? 'nodeItem connection' : 'nodeItem',style:({
          left: item.x + 'px',
          top: item.y + 'px',
        }),attrs:{"id":item.nodeId}},[_c('div',{staticClass:"nodeName",style:({
            'font-family': item.name == 'I' ? 'Ebrima' : 'SYHeiBold',
            'font-weight': item.name == 'I' ? 'bold' : '',
          })},[_vm._v(" "+_vm._s(item.name)+" ")])])}),0)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }